import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

import JavaView from '../views/JavaView.vue'
import JavaClassView from '../views/JavaClassView.vue'
import ClassView from '../views/ClassView.vue'
import CppView from '../views/CppView.vue'
import FaqView from '../views/FAQView.vue'
import CppClassView from '../views/CppClassView.vue'
import PythonView from '../views/PythonView.vue'
import PythonClassView from '../views/PythonClassView.vue'
import AlgorithmClassView from '@/views/AlgorithmClassView.vue'
import CoderView from '@/views/CoderView.vue'
import AlgorithmView from '@/views/AlgorithmView.vue'


import EntryView from '@/views/EntryView.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/class',
    name: 'class',
    component: ClassView
  },
  
  {
    path: '/entry',
    name: 'entry',
    component: EntryView
  },
 
  {
    path: '/java',
    name: 'java',
    component: JavaView
  },
  {
    path: '/java-class',
    name: 'javaclass',
    component: JavaClassView
  },
  {
    path: '/cpp',
    name: 'cpp',
    component: CppView
  },
  {
    path: '/cppclass',
    name: 'cppclass',
    component: CppClassView
  },
  {
    path: '/faq',
    name: 'faq',
    component: FaqView
  },
  {
    path: '/python',
    name: 'python',
    component: PythonView
  }

  ,
  {
    path: '/pythonclass',
    name: 'pythonClass',
    component: PythonClassView
  },
  {
    path: '/algorithm-class',
    name: 'algorithmclass',
    component: AlgorithmClassView
  },
  {
    path: '/algorithm',
    name: 'algorithm',
    component: AlgorithmView
  },
  {
    path: '/online-coding',
    name: 'coder',
    component: CoderView
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
